import React from 'react';
import DownloadCsvButton from '../DownloadCsvButton';
import { exportFormsToCsv } from '../../../services/formsCsvExportService';

const DownloadFormsCsvButton = () => (
    <DownloadCsvButton
        labelKey="app.page.product.form.downloadCSV"
        onExport={exportFormsToCsv}
    />
);

export default DownloadFormsCsvButton;
